// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../../fragments'

import {
  Spinner,
  SvgIcon,
  Feedback,
  Warning
} from '../../'

import { default as IdentityAddresses } from './IdentityAddresses'


export class EmployeeContactDetails extends React.PureComponent {
  static propTypes = {
    identityId: PropTypes.string.isRequired,
    loginButton: PropTypes.bool,
    readOnly: PropTypes.bool
  }

  static defaultProps = {
    loginButton: false,
    readOnly: false
  }

  state = {
    showActionModal: false,
    action: null
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' />
    }

    if (this.props.data.error) {
      return <Warning>Failed to load contact details.</Warning>
    }

    return (
      <React.Fragment>
        {this.state.showActionModal &&
          <Feedback
            message={this.state.action}
            fadeDuration={2500}  // 2.5s matches .feedback-fade css class animation
            unmount={() => this.setState({
              showActionModal: false,
              action: null
            })}
            icon={
              <SvgIcon
                variant='utility'
                symbol='check'
                colour='inverse'
                className='slds-align_absolute-center'
              />
            }
          />
        }
        <IdentityAddresses
          identity={this.props.data.identity}
          onActionSuccess={(action) => {
            this.setState({ showActionModal: true, action })
            this.props.data.refetch()
          }}
          onAddressSave={() => (
            this.setState({
              showActionModal: true,
              action: 'Restored'
            })
          )}
        />
      </React.Fragment>
    )
  }
}

const getIdentityAddresses = gql`
  query($id: ID!) {
    identity(id: $id) {
      id
      addresses {
        edges {
          node {
            ...Address
          }
        }
      }
    }
  }
  ${fragments.address}
`

const withData =
  graphql(getIdentityAddresses, {
    options: ({ identityId }) => ({
      variables: {
        id: identityId
      }
    })
  })

export default withData(EmployeeContactDetails)



// WEBPACK FOOTER //
// ./src/components/messageplus/employee-contact-details/index.js